<template>
  <div
    class="flex flex-col relative"
    @mouseenter="displayLabelTooltipOnHover"
    @mouseleave="forceHideTooltipLabel"
  >
    <div class="relative h-0">
      <transition
        enter-active-class="duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-300"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-show="tooltipLabel && libelle != null">
          <div
            :name="name"
            :class="backgroundColor+' '+textColor"
            class="tooltip-Label flex absolute rounded-lg shadow-lg text-xs z-50 py-5 px-6 bottom-3 right-0 w-max-content w-max max-w-64 md:max-w-72 xxl:max-w-128"
            v-html="libelle"
          />
        </div>
      </transition>
    </div>
    <div class="flex flex-row">
      <slot name="libelleBefore" />
      <div
        v-if="libelle != null"
        v-clickOutside="forceHideTooltipLabel"
        class="cursor-pointer"
        @click="displayLabelTooltip"
      >
        <icon
          :class="iconPosition+' '+iconColor"
          :name="icon"
        />
      </div>
    </div>
    <slot name="tooltipLibelleBefore" />
  </div>
</template>

<script>
import Icon from '../components/Icon';

export default {
  props: {
    name: String,
    libelle: String,
    icon:{
      type: String,
      required: false,
      default: 'info',
    },
    iconColor:{
      type: String,
      required: false,
      default: 'text-indigo-600',
    },
    textColor:{
      type: String,
      required: false,
      default: 'text-white',
    },
    backgroundColor:{
      type: String,
      required: false,
      default: 'bg-indigo-600',
    },
    sizeLess: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLibelleInput: {
      type: Boolean,
      required: false,
      default: false,
    },
    hoverable: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    Icon
  }
  ,
  data: function () {
    return {
      tooltipLabel: false,
    };
  },
  mounted() {
    //
  },
  methods: {
    displayLabelTooltipOnHover(e) {
      if (!this.hoverable) return;

      this.displayLabelTooltip(e);
    },
    displayLabelTooltip(e) {
      if (e.x < (2 * window.outerWidth / 3)) {
        document.querySelectorAll(`.tooltip-Label[name="${this.name}"]`)[0].classList.remove('right-0');
      }

      this.tooltipLabel = !this.tooltipLabel;
    },
    forceHideTooltipLabel(e) {
      if (e.target.classList.contains('tooltip-Label') && e.target.name == this.name) {
        this.tooltipLabel = !this.tooltipLabel;
      } else {
        if (this.tooltipLabel)
          this.tooltipLabel = false;
      }
    },
  },
  computed:{
    iconPosition(){
      if(this.isLibelleInput){
        return 'transform scale-75 ml-1 xl:-translate-y-1 2xl:-translate-y-0';
      }
      if(this.sizeLess){
        return 'transform scale-75';
      }
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>
